import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import MarvelLink from '@marvelapp/marvel-ui/link';
import Spacing from '@marvelapp/marvel-ui/spacing';

export default function FooterLink({ children, to, url, className, target }) {
  const marvelLinkProps = {
    url,
    target,
  };

  if (to) {
    return (
      <div className={className}>
        <Spacing type="margin" size="m" position="topBottom">
          <Link to={to}>
            <MarvelLink type="lightReversed" {...marvelLinkProps}>
              <span className="fontSize-m">{children}</span>
            </MarvelLink>
          </Link>
        </Spacing>
      </div>
    );
  }

  return (
    <div className={className}>
      <Spacing type="margin" size="m" position="topBottom">
        <MarvelLink type="lightReversed" {...marvelLinkProps}>
          <span className="fontSize-m">{children}</span>
        </MarvelLink>
      </Spacing>
    </div>
  );
}

FooterLink.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  target: PropTypes.string,
  to: PropTypes.string,
  url: PropTypes.string,
};

FooterLink.defaultProps = {
  target: '_blank',
};



// WEBPACK FOOTER //
// ./src/components/modules/Footer/FooterLink/index.js